module.exports = __webpack_public_path__ + "static/media/customize.7b41823b.svg";